import { create } from 'zustand';

interface MarkSoldStore {
	open: boolean;
	openMarkSold: () => void;
	closeMarkSold: () => void;
	setOpen: (open: boolean) => void;
}

/**
 * Global "Mark Cards as Sold" quick-sell tray.
 * Opened from the authed seller dropdowns (UserMenu, @me sheet, storefront owner menu).
 */
export const useMarkSoldStore = create<MarkSoldStore>((set) => ({
	open: false,
	openMarkSold: () => set({ open: true }),
	closeMarkSold: () => set({ open: false }),
	setOpen: (open) => set({ open }),
}));
